import { Component, HostListener, OnInit, SimpleChanges, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Subscription, lastValueFrom, filter } from 'rxjs';
import { Sort } from '@angular/material/sort';
import * as _ from 'lodash';
import { ActivatedRoute, Event, Router, RoutesRecognized } from '@angular/router';
import { Overlay } from '@angular/cdk/overlay';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { ITask, ITaskFilter } from '../task.interface';
import { TaskStatusesFilterOptions } from '../task.constants';
import { TaskModalComponent } from '../task-modal/task-modal.component';
import { TaskHttpService } from '../task-http.service';
import { TaskSingleComponent } from '../task-single/task-single.component';
import { ICategory } from '../../../categories-page/categories/categories.interface';
import { Broadcaster } from '../../../../shared/components/broadcaster.component';
import { DialogService } from '../../../../shared/services/dialog/dialog.service';
import { CategoriesService } from '../../../categories-page/categories/categories.service';
import { UtilsService } from '../../../../shared/services/utils.service';
import { AlertService } from '../../../../shared/services/alert.service';
import { AuthService } from '../../../../shared/services/auth.service';
import { BillingDocumentService } from '../../../billing-documents-page/billing-documents/billing-documents.service';
import { SettingsService } from '../../../settings-page/settings/settings.service';
import { AppointmentsService } from '../appoinment/appointment.service';
import { SETTINGS } from '../../../settings-page/settings/settings.constants';
import { IConfirmationDialogOptions } from '../../../../shared/services/dialog/confirmation-dialog/confirmation-dialog-options.interface';
import { ExternalRequestModalComponent } from '../../../../shared/components/external-request/external-request-modal/external-request-modal.component';
import { HelpVideoModalComponent } from '../../../../shared/components/help-video-modal/help-video-modal.component';
import { IDeleteTasksDialogOptions } from '../../../calendar-page/calendar-old/delete-tasks-dialog/delete-tasks-dialog-options.interface';

let self: any;

@Component({
  selector: 'app-task-list',
  templateUrl: './task-list.component.html',
  styleUrls: ['./task-list.component.css']
})
export class TaskListComponent implements OnInit {
  tasks: ITask[] = [];
  loading: boolean = false;
  thereAreMore: boolean = false;
  filter: ITaskFilter = {
    filters: {
      scheduledStart: new Date().toISOString().substring(0, 10),
      status: 'ACTIVE'
    },
    sort: '-scheduledStart',
    skip: 0,
    limit: 10000
  };
  filterAllData: any = {
    sort: '',
    skip: 0,
    limit: 4,
    filters: {}
  };
  filtered = false;
  scrollSubscription!: Subscription;
  routesSubscription!: Subscription;
  sortOptions: any = {
    "title": 'Titulo asc',
    "-title": 'Titulo desc',
    "status": 'Estado asc',
    "-status": 'Estado desc',
  };
  sortOptionsKeys = Object.keys(this.sortOptions);
  selection: any = { all: false };
  taskStatuses: any = TaskStatusesFilterOptions;
  taskStatusesKeys = Object.keys(TaskStatusesFilterOptions);
  isDev!: boolean;
  curr!: string;
  safeSrc: SafeResourceUrl;
  totalMoreMinTutorial = false;
  taskStatusColors: any = {};
  categories: ICategory[] = [];
  isMobile: boolean = false;
  querySubscription!: Subscription;

  constructor(
    public _TaskHttpService: TaskHttpService,
    private _broadcaster: Broadcaster,
    private _dialogService: DialogService,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
    public _CategoriesService: CategoriesService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _UtilsService: UtilsService,
    private _AlertService: AlertService,
    private _AuthService: AuthService,
    private _BillingDocumentService: BillingDocumentService,
    private _UtilService: UtilsService,
    private overlay: Overlay,
    private sanitizer: DomSanitizer,
    private _SettingsService: SettingsService,
    private breakpointObserver: BreakpointObserver,
    private _AppointmentService: AppointmentsService,
  ) {
    self = this;
    this.registerStringBroadcast();
    this.registerQueryParamChanges();
    this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/JT1Zf8dQCAk?si=X8J5MFkEm7ZMSbYE");
  }

  registerQueryParamChanges() {
    this.querySubscription = this._route.queryParams.subscribe(params => {
      if (params['action'] && parseInt(params['tp'] || '0') > (new Date().getTime() - (10 * 1000)) && (params['action'] == 'NEW'))
        setTimeout(() => this.openNewTaskModal('SCHEDULED'));
    })
  }

  ngOnInit() {
    this.isMobile = this.isMobileWidth();
    const customBreakpoint = this.breakpointObserver.observe([
      `(max-width: 991px)`
    ]);

    customBreakpoint.subscribe((state: BreakpointState) => {
      this.isMobile = state.matches;
    });
    this.getStatusColors();
    this.isDev = this._AuthService.isRole('dev');
    this.curr = this._AuthService.currency();
    this.filter.company = this._AuthService.companyId();
    this.filterAllData.company = this.filter.company;
    this._TaskHttpService.getTasks(this.filterAllData).subscribe((tasks: any) => {
      this.totalMoreMinTutorial = tasks.length > 3;
    });

    this._CategoriesService.getCategories({
      filters: { isDeleted: false },
      company: this._AuthService.companyId(),
      sort: 'name',
      skip: 0,
      limit: 1000
    }).subscribe((categories) => {
      this.categories = categories;
    });

    this.getTasks(true);
  }

  lazySearchTmp: number = 0;
  lazySearch() {
    let tmp = new Date().getTime();
    this.lazySearchTmp = tmp;
    setTimeout(() => {
      // console.log(tmp, this.lazySearchTmp);
      if (tmp == this.lazySearchTmp) {
        this.getTasks(true);
      }
    }, 1000);
  }

  getTasks(reset?: boolean) {
    this.loading = true;
    this.thereAreMore = false;
    if (reset) {
      window.scroll(0, 0);
      this.filter.skip = 0;
      this.tasks = [];
      this.clearSelection();
    }
    const filter: any = _.cloneDeep(this.filter);
    /*
    if (_.get(filter, 'filters.created_at_start'))
      filter.filters.created_at_start = new Date(filter.filters.created_at_start).getTime();
    if (_.get(filter, 'filters.created_at_end'))
      filter.filters.created_at_end = new Date(filter.filters.created_at_end).getTime();
      */
    // if (filter.filters.client == '') delete filter.filters.client;
    // if (filter.filters.title == '') delete filter.filters.title;
    // console.log(filter);

    /*
    if (filter.filters.dateStart)
      filter.filters.scheduledStart = this._UtilsService.date.toUTC(filter.filters.dateStart + 'T00:00:00.000Z');
    */
    /*
    if (filter.filters.dateEnd)
      filter.filters.scheduledEnd = this._UtilsService.date.toUTC(filter.filters.dateEnd + 'T23:59:59.999Z');
    */

    filter.filters.filterDate = this._UtilsService.date.toUTC(filter.filters.scheduledStart + 'T12:00:00.000Z');
    delete filter.filters.scheduledStart;

    this._TaskHttpService.getTasksByNext(filter).subscribe((tasks: any) => {
      this.tasks = _.concat(this.tasks, tasks);
      this.thereAreMore = tasks.length >= filter.limit;
      this.loading = false;
      // console.log(tasks)
    })
  }

  async getStatusColors() {
    this.taskStatusColors = { DEFAULT: 'white', SCHEDULED: '#337AB7', INVOICED: '#FF9E00' };
    this._SettingsService.getCompanySettingValue(SETTINGS.SCH_TASK_OPEN_COLOR)
      .then((color) => { this.taskStatusColors.OPEN = color; this.taskStatusColors.QUOTED = color });
    this._SettingsService.getCompanySettingValue(SETTINGS.SCH_TASK_ONGOING_COLOR)
      .then((color) => { this.taskStatusColors.ONGOING = color });
    this._SettingsService.getCompanySettingValue(SETTINGS.SCH_TASK_COMPLETED_COLOR)
      .then((color) => { this.taskStatusColors.COMPLETED = color });
    this._SettingsService.getCompanySettingValue(SETTINGS.SCH_TASK_CANCELLED_COLOR)
      .then((color) => { this.taskStatusColors.CANCELLED = color });
  }

  loadMore() {
    if (this.thereAreMore && !this.loading) {
      const filter: any = this.filter;
      filter.skip += filter.limit;
      this.getTasks();
    }
  }

  isMobileWidth(): boolean {
    if (typeof window !== 'undefined' && window.innerWidth > 991) {
      return false;
    }
    return true;
  }

  registerStringBroadcast() {
    this.scrollSubscription = this._broadcaster.on<string>('FinishScrollDown')
      .subscribe(() => {
        this.loadMore();
      });
  }

  ngOnDestroy() {
    this.scrollSubscription.unsubscribe();
  }

  sortTasks(sort: Sort | string) {
    this.filter.sort = (typeof sort == 'string') ? sort :
      ((sort.direction == 'asc') ? sort.active : ((sort.direction == 'desc') ? '-' + sort.active : ''));
    this.getTasks(true);
  }

  openFilter() {
    console.log('openFilter');
  }

  clearFilter() {
    this.filter.filters = {};
    this.getTasks(true);
  }

  openNewTaskModal(selected: string) {
    (selected === 'SCHEDULED') ? this.openCreateTasksModal({ status: selected }, true, false) : this.openCreateTasksModal({ status: selected }, undefined, false);
  }

  openCreateTasksModal(task: ITask, scheduling: boolean = false, readOnly: boolean = true) {
    let config = new MatDialogConfig();
    config.width = '1300px';
    config.maxWidth = '90vw';
    config.hasBackdrop = true;
    config.disableClose = true;
    config.scrollStrategy = this.overlay.scrollStrategies.block();
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(TaskModalComponent, config);
    self.dialogRef.componentInstance.task = task;
    self.dialogRef.componentInstance.scheduling = scheduling;
    self.dialogRef.componentInstance.readOnly = readOnly;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.getTasks(true);
    });
  }

  openTasksModal(task: ITask, scheduling: boolean = false, readOnly: boolean = true) {
    let config = new MatDialogConfig();
    config.width = '1300px';
    config.maxWidth = '90vw';
    config.hasBackdrop = true;
    config.disableClose = true;
    config.scrollStrategy = this.overlay.scrollStrategies.block();
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(TaskSingleComponent, config);
    self.dialogRef.componentInstance.task = task;
    self.dialogRef.componentInstance.scheduling = scheduling;
    self.dialogRef.componentInstance.readOnly = readOnly;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.getTasks(true);
    });
  }

  async openDuplicateTaskModal(task: ITask, readOnly: boolean = false) {
    task = await lastValueFrom(this._TaskHttpService.getTask(task));

    const modalOptions: IConfirmationDialogOptions = {
      title: "Duplicar Trabajo",
      message: "Está seguro que desea crear un nuevo trabajo copiando el contenido seleccionado?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };

    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          let data = _.cloneDeep(task);
          data.status = 'SCHEDULED';

          delete data._id;
          delete data.createdAt;
          delete data.createdBy;
          delete data.scheduledStart;
          delete data.scheduledEnd;
          delete data.appointment;
          // console.log(data)

          let config = new MatDialogConfig();
          // config.disableClose = true;
          config.width = '1300px';
          config.maxWidth = '90vw';
          config.viewContainerRef = this._viewContainerRef;
          self.dialogRef = this._dialog.open(TaskModalComponent, config);
          self.dialogRef.componentInstance.task = data;
          // self.dialogRef.componentInstance.readOnly = readOnly;
          self.dialogRef.componentInstance.readOnly = false;
          self.dialogRef.componentInstance.scheduling = true;

          self.dialogRef.afterClosed().subscribe((result: any) => {
            self.dialogRef = null;
            if (result) this.getTasks(true);
          });
        }
      });
  }

  openExternalRequestModal(task: ITask) {
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '700px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(ExternalRequestModalComponent, config);
    self.dialogRef.componentInstance.task = task;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.getTasks(true);
    });
  }

  openDeleteTaskConfirm(task: ITask, hardDelete: boolean = false) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Eliminar Trabajo",
      message: "Esta seguro que desea eliminar '" + task.title + "'?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._TaskHttpService.deleteTask(task, hardDelete).subscribe(() => {
            if (hardDelete) this.getTasks(true);
            else {
              task.isDeleted = true;
              task.status = 'CANCELLED';
            }
          })
        }
      });
  }

  openRestoreTaskConfirm(task: ITask) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Restaurar Trabajo",
      message: "Esta seguro que desea restaurar '" + task.title + "'?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._TaskHttpService.restoreTask(task).subscribe(() => {
            task.isDeleted = false;
          })
        }
      });
  }

  openHelpVideoModal() {
    let config = new MatDialogConfig();
    config.width = '1100px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(HelpVideoModalComponent, config);
    self.dialogRef.componentInstance.helpLink = this.safeSrc;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.getTasks(true);
    });
  }

  clearSelection() {
    this.selection = { all: false, some: false }
  }

  checkSomeSelected() {
    this.selection.some = Object.keys(this.selection)
      .filter(el => el !== 'all' && el !== 'some')
      .filter(el => this.selection[el])
      .length > 0;
  }

  toggleSelection(_id?: string) {
    if (_id) {
      // Modificar la selección de un elemento individual
      this.selection[_id] = !this.selection[_id];

      // Verificar si todos los elementos están seleccionados
      const allSelected = this.tasks.every(task => {
        const id = task.appointment?._id || '';
        return this.selection[id];
      });

      // Actualizar "seleccionar todos" en base a los elementos seleccionados
      this.selection.all = allSelected;
    } else {
      // Seleccionar o deseleccionar todos
      const newValue = !this.selection.all;
      this.selection = { all: newValue };

      // Aplicar el nuevo estado a todos los elementos
      this.tasks.forEach(task => {
        const id = task.appointment?._id || '';
        this.selection[id] = newValue;
      });
    }

    // Actualizar si hay alguna selección
    this.checkSomeSelected();
  }

  deleteManyAppo() {
    // return this.openDeleteUnderConstructionDialog();
    let manyAppt: any;
    // let appointments: string[] = [];
    let result: any = {
      appointments: []
    };
    if (this.selection.all === true) {
      for (let task of this.tasks) {
        result.appointments.push(task?.appointment?._id);
      }
    } else {
      for (let key in this.selection) {
        if (key !== 'all' && key !== 'some' && this.selection[key] === true) {
          result.appointments.push(key);
        }
      }
    }

    this._AppointmentService.checkDeleteManyAppointment(result).subscribe((result) => {
      manyAppt = result;
      // const untilMatch = dateToCheck.recurrence.recurrenceRule.match(/UNTIL=(\d{8})T/);
      // let untilDate = untilMatch ? this.formatDate(untilMatch[1]) : '';
      manyAppt.forEach((e: any) => {
        if (e.timetracks.length > 0 || e.billingdocuments.length > 0 || e.deliverynotes.length > 0) {
          e.canDeleted = false;
        } else {
          e.canDeleted = true;
        }
      });

      console.log(manyAppt);

      let totalDelete = manyAppt.filter((e: any) => e.canDeleted == true).length;
      let totalNotDelete = manyAppt.filter((e: any) => e.canDeleted == false).length;
      const modalDeleteOptions: IDeleteTasksDialogOptions = {
        title: "ATENCIÓN",
        message: "Se eliminarán " + totalDelete + " visitas\n(Las marcadas en rojo no seran eliminadas)",
        data: manyAppt
      };
      this._dialogService.openDeleteTasksModal(modalDeleteOptions, this._viewContainerRef).subscribe((confirmation: any) => {
        if (confirmation) {
          if (manyAppt.length > 0) {
            let data = manyAppt;
            this._AppointmentService.deleteManyAppointment(data).subscribe((result) => {
              this.tasks = [];
              this.getTasks();
            });
          }
        }
      })
    });
  };


  formatDate(dateString: string): string {
    const year = dateString.substring(0, 4);
    const month = dateString.substring(4, 6);
    const day = dateString.substring(6, 8);
    return `${day}/${month}/${year}`;
  }


  openTasksByStatus() {
    this._router.navigate(['/admin', this._AuthService.companyIndex(), 'tasks-status']);
  }

  openTasksByVisit() {
    this._router.navigate(['/admin', this._AuthService.companyIndex(), 'tasks']);
  }

  openTasksComments() {
    this._router.navigate(['/admin', this._AuthService.companyIndex(), 'tasks-comments']);
  }
}